export const mapMyEscalationToCaseData = (escalation, caseCategory) => {
    var _a, _b, _c, _d, _e, _f;
    const isConsumer = caseCategory === "Consumer";
    const product = isConsumer
        ? ((_a = escalation.product) === null || _a === void 0 ? void 0 : _a.name) || ""
        : [
            ...((_b = escalation.products) !== null && _b !== void 0 ? _b : []).map((item) => item.productName),
            ...((_c = escalation.programs) !== null && _c !== void 0 ? _c : []).map((item) => item.programName),
        ]
            .filter(Boolean)
            .join(",");
    const customerName = isConsumer
        ? ((_d = escalation.customerInfo) === null || _d === void 0 ? void 0 : _d.customerFirstName) || ""
        : ((_e = escalation.customerInfo) === null || _e === void 0 ? void 0 : _e.customerSegmentName) === "Consumer"
            ? escalation.customerInfo.customerFirstName
            : ((_f = escalation.accountInfo) === null || _f === void 0 ? void 0 : _f.companyName) || "NA";
    return {
        supportRequestNumber: escalation.supportRequestNumber || "",
        customerName,
        escalationId: escalation.escalationRequestNumber || (isConsumer ? "" : "NA"),
        product,
        status: escalation.status || "",
        submittedOn: escalation.createdOn,
        escalationFlowType: escalation.flowType || (isConsumer ? "Home User" : "Commercial"),
        stageCount: escalation.stageCount,
        currentStageIndex: escalation.currentStageIndex,
        stageText: escalation.stageText,
        isEscalationManagerCase: escalation.isEscalationManagerCase,
        caseCategory,
    };
};
